
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import SkillsSection from '@/components/SkillsSection';
import ExperienceSection from '@/components/ExperienceSection';
// import ProjectsSection from '@/components/ProjectsSection';
// import VideoResumeSection from '@/components/VideoResumeSection';
import PersonalSection from '@/components/PersonalSection';
import CertificationsSection from '@/components/CertificationsSection';
import BlogSection from '@/components/BlogSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import CustomCursor from '@/components/CustomCursor';
import ScrollToTop from '@/components/ScrollToTop';
import SubtleInteractions from '@/components/SubtleInteractions';

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden relative">
      {/* Custom cursor with enhanced configuration */}
      <CustomCursor 
        maxParticles={20} 
        colors={[
          'rgba(155, 135, 245, 0.7)', // purple
          'rgba(214, 188, 250, 0.7)', // light purple
          'rgba(255, 255, 255, 0.7)', // white
        ]}
        trailMode="gentle"
        particleSize={{ min: 0.8, max: 2.5 }}
        velocityRange={0.4}
        lifespan={1.2}
      />
      
      {/* Add subtle interactions */}
      <SubtleInteractions />
      
      {/* Animated background elements */}
      <div className="animated-bg-elem" style={{ top: '15%', left: '5%', animationDelay: '0s' }}></div>
      <div className="animated-bg-elem" style={{ top: '60%', right: '8%', animationDelay: '-5s', animationName: 'drift-reverse' }}></div>
      <div className="animated-bg-elem" style={{ bottom: '10%', left: '15%', animationDelay: '-10s', width: '300px', height: '300px' }}></div>
      
      {/* Scroll to top button */}
      <ScrollToTop />
      
      <Header />
      <main className="relative z-10 w-full">
        <HeroSection />
        <AboutSection />
        <SkillsSection />
        <ExperienceSection />

        {/* <ProjectsSection /> */}
        {/* <VideoResumeSection /> */}
        <PersonalSection />
        <CertificationsSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
